/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Location/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LocationChooser from './LocationChooser/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Location({
  children,
  viewPath = "/App/Account/Content/Settings/Content/NoteTemplates/Templates/Location"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Location.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Templates for"
 marginRight={dtSpaceS}
 weight="medium"
 size="normal"
 color={dtColorsNeutral500}
/>
<LocationChooser
  viewPath={`${viewPath}/LocationChooser`}
/>
</div>
{children}
</React.Fragment>)
}